module.exports = __webpack_public_path__ + "741d9cfd1ebb7fce5c2bffeff34b056e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/team/Leadership_Justin_0.jpg
// module id = 393
// module chunks = 0